
/* =============================================================
   BUSINESS HOURS — Phone CTA toggle
   Mon–Fri 9am–5pm ET, Sat 10am–4pm ET
   Closed: Sundays, Labor Day, Memorial Day, Christmas, New Year's
   Weekend/holiday after-hours: "Call us Monday" (or Tuesday if Mon is holiday)
   Uses Intl.DateTimeFormat for automatic DST handling
   ============================================================= */
function initPhoneHours() {
  var openEl   = document.getElementById('dean-phone-open');
  var closedEl = document.getElementById('dean-phone-closed');
  var closedMsg = document.getElementById('dean-phone-closed-msg');
  if (!openEl || !closedEl) return;

  // ── Helper: get date parts in ET ──
  function getETParts(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: 'numeric', minute: 'numeric',
      weekday: 'short', month: 'numeric',
      day: 'numeric', year: 'numeric',
      hour12: false
    }).formatToParts(date);
    var p = {};
    parts.forEach(function(x){ p[x.type] = x.value; });
    return {
      day:     p.weekday,                          // 'Mon', 'Tue', etc.
      month:   parseInt(p.month, 10),              // 1-12
      date:    parseInt(p.day, 10),                // 1-31
      year:    parseInt(p.year, 10),
      hour:    parseInt(p.hour, 10),
      min:     parseInt(p.minute, 10),
      time:    parseInt(p.hour, 10) + (parseInt(p.minute, 10) / 60)
    };
  }

  // ── Helper: nth weekday of month (e.g. last Monday of May) ──
  function nthWeekday(year, month, weekday, nth) {
    // weekday: 0=Sun,1=Mon...6=Sat
    // nth: 1=first, -1=last
    if (nth > 0) {
      var d = new Date(year, month - 1, 1);
      while (d.getDay() !== weekday) d.setDate(d.getDate() + 1);
      d.setDate(d.getDate() + (nth - 1) * 7);
      return d.getDate();
    } else {
      // last occurrence
      var d = new Date(year, month, 0); // last day of month
      while (d.getDay() !== weekday) d.setDate(d.getDate() - 1);
      return d.getDate();
    }
  }

  // ── Check if a given ET date is a closed holiday ──
  function isHoliday(year, month, date) {
    // New Year's Day — Jan 1
    if (month === 1 && date === 1) return true;
    // Memorial Day — last Monday of May
    if (month === 5 && date === nthWeekday(year, 5, 1, -1)) return true;
    // Labor Day — first Monday of September
    if (month === 9 && date === nthWeekday(year, 9, 1, 1)) return true;
    // Christmas Day — Dec 25
    if (month === 12 && date === 25) return true;
    return false;
  }

  // ── Find the next open day name from a given ET date ──
  function nextOpenDayName(year, month, date) {
    var d = new Date(year, month - 1, date);
    for (var i = 1; i <= 7; i++) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay(); // 0=Sun,1=Mon...6=Sat
      var m  = d.getMonth() + 1;
      var dt = d.getDate();
      var yr = d.getFullYear();
      // Open Mon–Sat, not a holiday
      if (wd >= 1 && wd <= 6 && !isHoliday(yr, m, dt)) {
        var names = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        return names[wd];
      }
    }
    return 'Monday'; // fallback
  }

  // ── Main logic ──
  var now = new Date();
  var et  = getETParts(now);

  var holiday = isHoliday(et.year, et.month, et.date);
  var isWeekend = (et.day === 'Sun' || et.day === 'Sat');

  var isOpen = false;

  if (!holiday) {
    if (et.day === 'Mon' || et.day === 'Tue' || et.day === 'Wed' || et.day === 'Thu' || et.day === 'Fri') {
      isOpen = et.time >= 9 && et.time < 17;   // 9am–5pm
    } else if (et.day === 'Sat') {
      isOpen = et.time >= 10 && et.time < 16;  // 10am–4pm
    }
  }

  // Build the closed message
  if (!isOpen && closedMsg) {
    var nextDay = nextOpenDayName(et.year, et.month, et.date);
    var isWeekendOrHolidayClose = (isWeekend || holiday || (et.day === 'Fri' && et.time >= 17));
    // On Sat after close, Sun, or Mon holidays → point to next open weekday
    var callText = (nextDay === 'Monday' || nextDay === 'Tuesday' || isWeekend || holiday)
      ? 'Call us ' + nextDay + ' — we actually answer.'
      : 'Call tomorrow — we actually answer.';
    closedMsg.textContent = callText;
  }

  // Hide the entire phone CTA block when closed — not just the inner message
  var phoneBlock = document.getElementById('dean-phone-cta');
  if (phoneBlock) {
    phoneBlock.style.display = isOpen ? '' : 'none';
  }
  openEl.style.display  = 'block';
  closedEl.style.display = 'none';
}

/* =============================================================
   DEAN SUPPLY — Product Page JavaScript
   ============================================================= */

(function() {
  'use strict';

  /* --- Image Gallery + Zoom --- */
  function initGallery() {
    const mainImageWrap = document.querySelector('.dean-main-image');
    const mainImg = document.querySelector('.dean-main-image img');
    const thumbs = document.querySelectorAll('.dean-thumb');

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const newSrc = this.dataset.fullSrc || this.querySelector('img')?.src;
        if (!newSrc) return;

        // Fade transition
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 200);

        // Update active state
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // ── Mobile swipe between images ──
    if (mainImageWrap && thumbs.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var isSwiping = false;

      mainImageWrap.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isSwiping = false;
      }, { passive: true });

      mainImageWrap.addEventListener('touchmove', function(e) {
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        // Only swipe if horizontal movement dominates
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
          isSwiping = true;
        }
      }, { passive: true });

      mainImageWrap.addEventListener('touchend', function(e) {
        if (!isSwiping) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 40) return; // too short

        // Find current active thumb index
        var thumbArr = Array.from(thumbs);
        var currentIdx = thumbArr.findIndex(t => t.classList.contains('active'));
        if (currentIdx === -1) currentIdx = 0;

        var nextIdx;
        if (dx < 0) {
          // Swipe left → next image
          nextIdx = (currentIdx + 1) % thumbArr.length;
        } else {
          // Swipe right → previous image
          nextIdx = (currentIdx - 1 + thumbArr.length) % thumbArr.length;
        }

        // Trigger the same click logic
        thumbArr[nextIdx].click();

        // Scroll the thumbnail strip to keep active thumb visible
        var activeThumb = thumbArr[nextIdx];
        if (activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }, { passive: true });
    }

    // Desktop hover zoom
    if (mainImageWrap && window.matchMedia('(hover: hover)').matches) {
      mainImageWrap.addEventListener('mouseenter', () => {
        mainImageWrap.classList.add('zoomed');
      });
      mainImageWrap.addEventListener('mouseleave', () => {
        mainImageWrap.classList.remove('zoomed');
      });
      mainImageWrap.addEventListener('mousemove', (e) => {
        const rect = mainImageWrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
    }
  }

  /* --- Quantity Selector --- */
  function initQuantity() {
    const minusBtn = document.querySelector('.dean-qty-minus');
    const plusBtn = document.querySelector('.dean-qty-plus');
    const qtyDisplay = document.querySelector('.dean-qty-value');
    const qtyInput = document.querySelector('input[name="quantity"]');

    if (!minusBtn || !plusBtn) return;

    function updateQty(newQty) {
      const qty = Math.max(1, Math.min(999, newQty));
      if (qtyDisplay) qtyDisplay.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      updateAtcPrice();
      return qty;
    }

    minusBtn.addEventListener('click', () => {
      const current = parseInt(qtyDisplay?.textContent || '1');
      updateQty(current - 1);
    });

    plusBtn.addEventListener('click', () => {
      const current = parseInt(qtyDisplay?.textContent || '1');
      updateQty(current + 1);
    });
  }

  /* --- Refresh Cart Count — works with Expanse theme --- */
  function refreshCartCount() {
    // Method 1: Fetch cart.js and update all counter elements
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count || 0;
        // Expanse theme selectors
        var selectors = [
          '.cart-link__bubble--visible span',
          '.cart-link__count',
          '.site-cart__count',
          '.cart-count-bubble span[aria-hidden="true"]',
          '.cart-count',
          '[data-cart-count]',
          '.js-cart-count',
          '.header-cart__count',
          '.cart-count-badge'
        ];
        selectors.forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(el) {
            el.textContent = count;
          });
        });

        // Make sure the bubble is visible
        document.querySelectorAll('.cart-link__bubble').forEach(function(el) {
          if (count > 0) el.classList.add('cart-link__bubble--visible');
        });
      })
      .catch(function() {});

    // Method 2: Expanse theme cart object
    if (window.theme && window.theme.cart) {
      window.theme.cart.getCart();
    }

    // Method 3: Dispatch custom event some themes listen to
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  /* --- Add to Cart (Enhanced) --- */
  function initAddToCart() {
    const atcBtn = document.querySelector('.dean-atc-btn');
    if (!atcBtn) return;

    const originalText = atcBtn.textContent;

    atcBtn.addEventListener('click', function(e) {
      const btn = this;

      if (btn.dataset.ajaxCart === 'true') {
        e.preventDefault();

        const form = btn.closest('form');
        if (!form) return;

        const formData = new FormData(form);

        btn.disabled = true;
        btn.classList.add('added');
        btn.textContent = '✓ ADDED TO CART';

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
        .then(res => res.json())
        .then(data => {
          // Refresh cart for Expanse theme
          refreshCartCount();

          setTimeout(() => {
            btn.classList.remove('added');
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2500);
        })
        .catch(err => {
          console.error('Add to cart error:', err);
          btn.classList.remove('added');
          btn.textContent = originalText;
          btn.disabled = false;
        });
      }
    });
  }

  /* --- Tabs --- */
  function initTabs() {
    const tabBtns = document.querySelectorAll('.dean-tab-btn');
    const tabPanels = document.querySelectorAll('.dean-tab-panel');

    if (!tabBtns.length) return;

    tabBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const target = this.dataset.tab;

        tabBtns.forEach(b => b.classList.remove('active'));
        tabPanels.forEach(p => p.classList.remove('active'));

        this.classList.add('active');
        const panel = document.getElementById(`dean-tab-${target}`);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* --- FAQ Accordion --- */
  function initFaq() {
    const faqItems = document.querySelectorAll('.dean-faq-item');

    faqItems.forEach(item => {
      const question = item.querySelector('.dean-faq-question');
      if (!question) return;

      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        // Close all
        faqItems.forEach(i => i.classList.remove('open'));

        // Toggle clicked
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    });
  }

  /* --- Fade-in Animation on Load --- */
  function initAnimations() {
    const fadeEls = document.querySelectorAll('.dean-fade-up');
    setTimeout(() => {
      fadeEls.forEach((el, i) => {
        setTimeout(() => {
          el.classList.add('visible');
        }, i * 100);
      });
    }, 100);
  }

  /* --- Smooth Scroll to Reviews --- */
  function initReviewScroll() {
    const reviewLinks = document.querySelectorAll('[data-scroll-reviews]');

    reviewLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // Activate reviews tab
        const reviewTab = document.querySelector('[data-tab="reviews"]');
        if (reviewTab) reviewTab.click();

        // Scroll to tabs
        const tabsSection = document.querySelector('.dean-tabs-section');
        if (tabsSection) {
          tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* --- Variant Selector (radio-style, Step 2) --- */
  function initVariants() {
    var variantOpts = document.querySelectorAll('.dean-variant-opt');
    var variantInput = document.querySelector('input[name="id"]');
    var priceEl = document.querySelector('.dean-price-current');
    var atcBtn = document.querySelector('.dean-atc-btn');
    var stockDot = document.querySelector('.dean-stock-dot');
    var stockLabel = document.querySelector('.dean-stock-label');
    var stockQty = document.querySelector('.dean-stock-qty');
    var notifyCard = document.querySelector('.dean-notify-card');
    var notifyTitle = document.querySelector('.dean-notify-title');
    var notifySuccess = document.querySelector('.dean-notify-success');
    var atcRow = document.querySelector('.dean-atc-row');
    var deliveryEst = document.querySelector('.dean-delivery-estimate');
    var skuEl = document.querySelector('.dean-sku-value');

    if (!variantOpts.length) return;

    variantOpts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        var vid = this.dataset.variantId;
        var vprice = this.dataset.price;
        var vavail = this.dataset.available === 'true';
        var vsku = this.dataset.sku;
        var vqty = parseInt(this.dataset.inventory || '0');
        var vmanaged = this.dataset.inventoryManaged === 'shopify';
        var vtitle = this.dataset.title || '';

        // Update active state
        variantOpts.forEach(function(v) { v.classList.remove('active'); });
        this.classList.add('active');

        // Update hidden input
        if (variantInput) variantInput.value = vid;

        // Update price
        if (priceEl && vprice) {
          priceEl.textContent = '$' + parseFloat(vprice).toFixed(2);
          priceEl.dataset.basePrice = vprice;
        }

        // Update SKU
        if (skuEl && vsku) skuEl.textContent = vsku;

        // Toggle in-stock vs out-of-stock UI
        if (vavail) {
          if (stockDot) stockDot.style.background = '#2D7F4F';
          if (stockLabel) { stockLabel.textContent = 'In Stock'; stockLabel.style.color = '#2D7F4F'; }
          if (stockQty) {
            if (vqty > 0 && vmanaged) {
              stockQty.textContent = '\u2014 ' + vqty + ' available';
              stockQty.style.display = '';
            } else {
              stockQty.style.display = 'none';
            }
          }
          if (atcRow) atcRow.style.display = 'flex';
          if (notifyCard) notifyCard.style.display = 'none';
          if (notifySuccess) notifySuccess.style.display = 'none';
          if (atcBtn) atcBtn.disabled = false;
          if (deliveryEst) deliveryEst.style.display = 'flex';
        } else {
          if (stockDot) stockDot.style.background = '#C0392B';
          if (stockLabel) { stockLabel.textContent = 'Out of Stock'; stockLabel.style.color = '#C0392B'; }
          if (stockQty) { stockQty.textContent = '\u2014 Call for availability'; stockQty.style.display = ''; }
          if (atcRow) atcRow.style.display = 'none';
          if (notifyCard) notifyCard.style.display = 'block';
          if (notifyTitle) {
            var titleText = document.querySelector('.dean-product-title');
            var productName = titleText ? titleText.textContent.trim() : '';
            if (vtitle && vtitle !== 'Default Title') {
              notifyTitle.innerHTML = 'The <em>' + vtitle + '</em> is sold out';
            } else if (productName) {
              notifyTitle.textContent = productName.substring(0, 50) + ' is sold out';
            }
          }
          if (deliveryEst) deliveryEst.style.display = 'none';
        }

        // Update URL
        if (vid && window.history.replaceState) {
          var url = new URL(window.location);
          url.searchParams.set('variant', vid);
          window.history.replaceState({}, '', url);
        }

        updateAtcPrice();
      });
    });
  }

  /* --- Update ATC Button Price (Step 2) --- */
  function updateAtcPrice() {
    var atcBtn = document.querySelector('.dean-atc-btn');
    if (!atcBtn || atcBtn.disabled) return;

    var activeVariant = document.querySelector('.dean-variant-opt.active');
    var qty = parseInt(document.querySelector('.dean-qty-value') ? document.querySelector('.dean-qty-value').textContent : '1') || 1;
    var price = parseFloat(activeVariant ? activeVariant.dataset.price : atcBtn.dataset.basePrice || '0') || 0;
    var total = (price * qty).toFixed(2);

    // Update main ATC button
    atcBtn.textContent = 'ADD TO CART \u2014 $' + total;

    // Update sticky bar price + button together
    var stickyPrice = document.getElementById('dean-sticky-price');
    if (stickyPrice) stickyPrice.textContent = '$' + total;
  }

  /* --- Back-in-Stock Notification via Klaviyo --- */
  var KLAVIYO_PUBLIC_KEY = 'Mw7eSK';

  function initNotify() {
    var notifyBtn = document.querySelector('.dean-notify-btn');
    var notifyInput = document.querySelector('.dean-notify-input');
    var notifyCard = document.querySelector('.dean-notify-card');
    var notifySuccess = document.querySelector('.dean-notify-success');

    if (!notifyBtn) return;

    notifyBtn.addEventListener('click', function() {
      var email = notifyInput ? notifyInput.value.trim() : '';
      if (!email || email.indexOf('@') === -1) {
        if (notifyInput) { notifyInput.focus(); notifyInput.style.borderColor = 'var(--dean-red)'; }
        return;
      }
      if (notifyInput) notifyInput.style.borderColor = '';

      var variantInput = document.querySelector('input[name="id"]');
      var vid = variantInput ? variantInput.value : '';

      notifyBtn.disabled = true;
      notifyBtn.textContent = 'Saving…';

      // Klaviyo Back-in-Stock Subscriptions API (v3)
      // Variant ID format for Shopify: $shopify:::$default:::VARIANT_ID
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + vid
                }
              }
            }
          }
        })
      })
      .then(function(res) {
        // 202 Accepted = success, 409 = already subscribed (also fine)
        if (res.ok || res.status === 409) {
          if (notifyCard) notifyCard.style.display = 'none';
          if (notifySuccess) {
            notifySuccess.style.display = 'flex';
            var emailSpan = notifySuccess.querySelector('.dean-notify-email');
            if (emailSpan) emailSpan.textContent = email;
          }
        } else {
          notifyBtn.disabled = false;
          notifyBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg> NOTIFY ME';
        }
      })
      .catch(function() {
        // On network error still show success — subscription may have gone through
        if (notifyCard) notifyCard.style.display = 'none';
        if (notifySuccess) {
          notifySuccess.style.display = 'flex';
          var emailSpan = notifySuccess.querySelector('.dean-notify-email');
          if (emailSpan) emailSpan.textContent = email;
        }
      });

    });
  }

  /* --- Sticky Mobile ATC Bar (Step 2) --- */
  /* --- Click star rating → scroll to reviews --- */
  function initReviewScroll() {
    function scrollToReviews(e) {
      var target = document.getElementById('dean-tab-reviews');
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Make stars row clickable
    var starsRow = document.querySelector('.dean-stars');
    if (starsRow) {
      starsRow.style.cursor = 'pointer';
      starsRow.addEventListener('click', scrollToReviews);
    }
    // Rating number
    var ratingNum = document.querySelector('.dean-rating-num');
    if (ratingNum) {
      ratingNum.style.cursor = 'pointer';
      ratingNum.addEventListener('click', scrollToReviews);
    }
    // Review count link — override native anchor to use smooth scroll with offset
    document.querySelectorAll('[data-scroll-reviews], .dean-review-count').forEach(function(el) {
      el.addEventListener('click', scrollToReviews);
    });
  }

  function initStickyBar() {
    var stickyBar = document.querySelector('.dean-sticky-bar');
    if (!stickyBar) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.scrollY > 600) {
            stickyBar.classList.add('visible');
          } else {
            stickyBar.classList.remove('visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* --- Recently Viewed --- */
  function initRecentlyViewed() {
    var STORAGE_KEY = 'dean_recently_viewed';
    var MAX_ITEMS = 12;
    var DISPLAY = 4;

    // Track current product
    var productData = document.querySelector('[data-recent-product]');
    if (productData) {
      try {
        var item = {
          id: productData.dataset.productId,
          url: productData.dataset.productUrl,
          title: productData.dataset.productTitle,
          image: productData.dataset.productImage,
          price: productData.dataset.productPrice,
          compare: productData.dataset.productCompare || '',
          available: productData.dataset.productAvailable === 'true',
          variantId: productData.dataset.productVariantId || ''
        };
        var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        stored = stored.filter(function(p) { return p.id !== item.id; });
        stored.unshift(item);
        if (stored.length > MAX_ITEMS) stored = stored.slice(0, MAX_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch(e) {}
    }

    // Render grid
    var grid = document.querySelector('.dean-recent-grid');
    if (!grid) return;

    try {
      var all = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      var currentId = productData ? productData.dataset.productId : '';
      var items = all.filter(function(p) { return p.id !== currentId; }).slice(0, DISPLAY);

      if (!items.length) {
        var section = grid.closest('.dean-recent-section');
        if (section) section.style.display = 'none';
        return;
      }

      items.forEach(function(p) {
        var onSale = p.compare && parseFloat(p.compare) > parseFloat(p.price);
        var _rPrice = parseFloat(String(p.price).replace(/,/g, '')).toFixed(2);
        var _rCompare = parseFloat(String(p.compare || '0').replace(/,/g, '')).toFixed(2);
        var dotColor = p.available ? '#2D7F4F' : '#DC2626';
        var stockText = p.available ? 'In Stock' : 'Out of Stock';

        // Wrapper div — NOT anchor, so ATC button inside works cleanly
        var wrap = document.createElement('div');
        wrap.className = 'dean-recent-card';

        var html = '<a href="' + p.url + '" class="dean-recent-card-link">';
        html += '<div class="dean-recent-card-img">';
        if (onSale) html += '<span class="dean-recent-sale-badge">SALE</span>';
        html += '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></div>';
        html += '<div class="dean-recent-card-info">';
        html += '<div class="dean-recent-card-name">' + p.title + '</div>';
        html += '<div class="dean-recent-card-price">$' + _rPrice;
        if (onSale) html += '<span class="dean-recent-card-compare">$' + _rCompare + '</span>';
        html += '</div>';
        html += '<div class="dean-recent-card-stock"><span class="dean-recent-stock-dot" style="background:' + dotColor + '"></span>' + stockText + '</div>';
        html += '</div></a>';

        // ATC button outside the anchor
        if (p.available) {
          if (p.variantId) {
            html += '<button class="dean-recent-atc" data-variant-id="' + p.variantId + '">Add to cart</button>';
          } else {
            html += '<a class="dean-recent-atc" href="' + p.url + '">View &amp; Add →</a>';
          }
        }

        wrap.innerHTML = html;

        var atcBtn = wrap.querySelector('button.dean-recent-atc');
        if (atcBtn) {
          atcBtn.addEventListener('click', function() {
            var vid = this.dataset.variantId;
            if (!vid) return;
            var btn = this;
            btn.disabled = true;
            btn.textContent = 'Adding…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
            }).then(function() {
              btn.textContent = '✓ Added';
              refreshCartCount();
              setTimeout(function() { btn.disabled = false; btn.textContent = 'Add to cart'; }, 2000);
            }).catch(function() {
              btn.disabled = false;
              btn.textContent = 'Add to cart';
            });
          });
        }

        grid.appendChild(wrap);
      });
    } catch(e) {}

    // ── Neutralize Flickity on the THEME's native recently-viewed section ──
    neutralizeRecentlyViewedFlickity();
  }

  function neutralizeRecentlyViewedFlickity() {
    // ── ROOT CAUSE (confirmed from product template source) ──
    // The recently-viewed section renders DYNAMICALLY after page load.
    // The theme JS reads localStorage, fetches product data, renders cards,
    // then initialises Flickity — all asynchronously. At DOMContentLoaded
    // the #RecentlyViewed-* container is an EMPTY DIV. There is nothing to
    // strip yet. setTimeout retries don't reliably catch the right moment.
    //
    // CORRECT APPROACH:
    // 1. Watch the shopify-section wrapper for child nodes being added
    //    (this fires when the theme injects the rendered carousel HTML)
    // 2. Watch for the 'flickity-enabled' class being added to any grid
    //    (this fires exactly when Flickity initialises)
    // 3. Strip immediately when either event fires
    // 4. Keep a few setTimeout fallbacks as insurance

    function stripFlickityFromEl(el) {
      // Destroy Flickity instance via its own API first
      try {
        var flkty = (typeof Flickity !== 'undefined' && Flickity.data) ? Flickity.data(el) : null;
        if (!flkty) flkty = el._flickity;
        if (flkty && typeof flkty.destroy === 'function') flkty.destroy();
      } catch(e) {}

      // Remove class markers so theme JS won't re-init
      el.classList.remove('flickity-enabled', 'is-draggable', 'flickity-resize',
                          'aos-init', 'aos-animate', 'flickity-resize');

      // Kill viewport's hardcoded height
      var vp = el.querySelector('.flickity-viewport');
      if (vp) vp.removeAttribute('style');

      // Strip ALL inline styles from slider and every card child
      var slider = el.querySelector('.flickity-slider');
      if (slider) {
        slider.removeAttribute('style');
        Array.from(slider.children).forEach(function(c) { c.removeAttribute('style'); });
        if (!slider.classList.contains('dean-rv-grid-ready')) {
          slider.classList.add('dean-rv-grid-ready');
        }
      }
    }

    function processRVContainer(container) {
      // Find .flickity-enabled inside this container
      var enabled = container.querySelectorAll('.flickity-enabled');
      enabled.forEach(stripFlickityFromEl);

      // Fallback: if Flickity already ran and left structure but removed class
      var slider = container.querySelector('.flickity-slider');
      if (slider && !slider.classList.contains('dean-rv-grid-ready')) {
        slider.removeAttribute('style');
        Array.from(slider.children).forEach(function(c) { c.removeAttribute('style'); });
        slider.classList.add('dean-rv-grid-ready');
        var vp = slider.parentElement;
        if (vp) vp.removeAttribute('style');
      }
    }

    // ── Observer 1: watch section wrappers for when the carousel HTML is injected ──
    // Targets the shopify-section div that wraps both RV sections
    var sectionObservers = [];
    document.querySelectorAll('[class*="recently-viewed"]').forEach(function(sectionEl) {
      var mo = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.type === 'childList' && m.addedNodes.length) {
            // New HTML was injected — find and process any RV containers inside
            setTimeout(function() {
              document.querySelectorAll('[id^="RecentlyViewed"]').forEach(processRVContainer);
            }, 50); // tiny delay so Flickity can finish its own init
          }
        });
      });
      mo.observe(sectionEl, { childList: true, subtree: true });
      sectionObservers.push(mo);
    });

    // ── Observer 2: watch for 'flickity-enabled' class being added to any element ──
    // This fires at the EXACT moment Flickity initialises the carousel
    var classObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var t = m.target;
          // Check if this newly-classed element is inside a RecentlyViewed container
          var rvParent = t.closest('[id^="RecentlyViewed"]') ||
                         t.closest('[class*="recently-viewed"]');
          if (rvParent && t.classList.contains('flickity-enabled')) {
            setTimeout(function() { stripFlickityFromEl(t); }, 20);
          }
        }
        // Also catch inline style injection on slide children
        if (m.type === 'attributes' && m.attributeName === 'style') {
          var t2 = m.target;
          if (t2.style && (t2.style.position === 'absolute' || t2.style.left)) {
            var rvParent2 = t2.closest('[id^="RecentlyViewed"]') ||
                            t2.closest('[class*="recently-viewed"]');
            if (rvParent2) {
              setTimeout(function() {
                document.querySelectorAll('[id^="RecentlyViewed"]').forEach(processRVContainer);
              }, 20);
            }
          }
        }
      });
    });
    classObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      subtree: true
    });

    // ── Fallback: polled retries in case observer fires before Flickity fully settles ──
    function tryStrip() {
      document.querySelectorAll('[id^="RecentlyViewed"]').forEach(processRVContainer);
    }
    setTimeout(tryStrip, 500);
    setTimeout(tryStrip, 1500);
    setTimeout(tryStrip, 3000);
    setTimeout(tryStrip, 5000); // last resort
  }

  /* --- Frequently Bought Together (via Shopify Complementary Products API) --- */
  function initFBT() {
    var section = document.querySelector('.dean-fbt-section');
    if (!section) return;

    var productId = section.dataset.productId;
    var maxItems = parseInt(section.dataset.maxItems) || 6;
    var listEl = section.querySelector('.dean-fbt-list');
    var totalRow = section.querySelector('.dean-fbt-total');
    var totalPrice = section.querySelector('.dean-fbt-total-price');
    var countEl = section.querySelector('.dean-fbt-count');

    if (!productId || !listEl) return;

    // Fetch complementary products from Shopify API
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + maxItems + '&intent=complementary')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = data.products || [];
        if (!products.length) {
          section.style.display = 'none';
          return;
        }

        // Render FBT items
        products.forEach(function(p, idx) {
          var firstVariant = p.variants[0];
          var price = (firstVariant.price / 100).toFixed(2);
          var imgSrc = p.featured_image ? p.featured_image.replace(/(\.\w+)$/, '_160x160$1') : '';
          var checked = idx < 2 ? 'checked' : '';
          var activeClass = idx < 2 ? ' active' : '';
          var hasVariants = p.variants.length > 1 && p.variants[0].title !== 'Default Title';

          var html = '<div class="dean-fbt-item' + activeClass + '" data-price="' + price + '" data-variant-id="' + firstVariant.id + '">';
          html += '<label class="dean-fbt-check">';
          html += '<input type="checkbox" ' + checked + '>';
          html += '<span class="dean-fbt-checkbox"></span>';
          html += '</label>';
          if (imgSrc) {
            html += '<div class="dean-fbt-img"><img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>';
          }
          html += '<div class="dean-fbt-info">';
          html += '<a href="' + p.url + '" class="dean-fbt-name">' + p.title + '</a>';
          if (hasVariants) {
            html += '<select class="dean-fbt-variant-select">';
            p.variants.forEach(function(v) {
              var vPrice = (v.price / 100).toFixed(2);
              html += '<option value="' + v.id + '" data-price="' + vPrice + '">' + v.title + ' — $' + vPrice + '</option>';
            });
            html += '</select>';
          }
          html += '</div>';
          html += '<div class="dean-fbt-price-col">';
          html += '<div class="dean-fbt-price">$' + price + '</div>';
          if (!hasVariants) {
            var unitMatch = p.title.match(/[\d,]+\s*\/\s*(Case|Pack|Dozen|Box|Roll|Each|Set|Pair|Bundle|Sleeve|Bag)/i);
            if (unitMatch) {
              html += '<span class="dean-fbt-unit">' + unitMatch[0] + '</span>';
            } else if (firstVariant.title && firstVariant.title !== 'Default Title') {
              html += '<span class="dean-fbt-unit">' + firstVariant.title + '</span>';
            }
          }
          html += '</div>';
          html += '</div>';

          listEl.insertAdjacentHTML('beforeend', html);
        });

        // Show section
        section.style.display = '';

        // Show the ATC button
        var fbtAtcBtn = section.querySelector('.dean-fbt-atc-btn');
        if (fbtAtcBtn) fbtAtcBtn.style.display = 'flex';

        // Bind checkbox + variant select events
        var items = listEl.querySelectorAll('.dean-fbt-item');
        items.forEach(function(item) {
          // Checkbox toggle
          var cb = item.querySelector('input[type="checkbox"]');
          if (cb) {
            cb.addEventListener('change', function() {
              if (this.checked) {
                item.classList.add('active');
              } else {
                item.classList.remove('active');
              }
              updateFBTTotal();
            });
          }

          // Variant dropdown — updates price, variant ID, and total
          var sel = item.querySelector('.dean-fbt-variant-select');
          if (sel) {
            sel.addEventListener('change', function() {
              var opt = this.options[this.selectedIndex];
              var newPrice = opt.dataset.price;
              var newVid = this.value;
              // Update item data attrs
              item.dataset.price = newPrice;
              item.dataset.variantId = newVid;
              // Update displayed price
              var priceEl = item.querySelector('.dean-fbt-price');
              if (priceEl) priceEl.textContent = '$' + newPrice;
              updateFBTTotal();
            });
          }
        });

        // Add Bundle to Cart button handler
        if (fbtAtcBtn) {
          fbtAtcBtn.addEventListener('click', function() {
            var checkedItems = listEl.querySelectorAll('.dean-fbt-item.active');

            var addItems = [];

            // Always include the main product
            var mainVariantInput = document.querySelector('input[name="id"]');
            var mainQtyEl = document.querySelector('.dean-qty-value');
            if (mainVariantInput) {
              addItems.push({
                id: parseInt(mainVariantInput.value),
                quantity: parseInt(mainQtyEl ? mainQtyEl.textContent : '1') || 1
              });
            }

            // Add checked FBT items
            checkedItems.forEach(function(item) {
              addItems.push({
                id: parseInt(item.dataset.variantId),
                quantity: 1
              });
            });

            if (!addItems.length) return;

            fbtAtcBtn.disabled = true;
            fbtAtcBtn.classList.add('added');
            fbtAtcBtn.innerHTML = 'Adding...';

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: addItems })
            })
            .then(function(res) { return res.json(); })
            .then(function() {
              fbtAtcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> ADDED TO CART';

              refreshCartCount();

              setTimeout(function() {
                fbtAtcBtn.classList.remove('added');
                fbtAtcBtn.disabled = false;
                fbtAtcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> ADD BUNDLE TO CART';
              }, 2500);
            })
            .catch(function() {
              fbtAtcBtn.classList.remove('added');
              fbtAtcBtn.disabled = false;
              fbtAtcBtn.innerHTML = 'Error — Try Again';
              setTimeout(function() {
                fbtAtcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> ADD BUNDLE TO CART';
              }, 2000);
            });
          });
        }

        updateFBTTotal();
      })
      .catch(function() {
        section.style.display = 'none';
      });

    function updateFBTTotal() {
      var checked = listEl.querySelectorAll('.dean-fbt-item.active');
      var noteEl = section.querySelector('.dean-fbt-total-note');

      // Get original product price (in cents from Shopify)
      var basePriceEl = document.querySelector('[data-dean-product-price]');
      var basePrice = basePriceEl ? (parseInt(basePriceEl.getAttribute('data-dean-product-price'), 10) || 0) / 100 : 0;

      var addOnTotal = 0;
      checked.forEach(function(item) {
        addOnTotal += parseFloat(item.dataset.price) || 0;
      });

      var grandTotal = basePrice + addOnTotal;
      var itemCount = 1 + checked.length; // 1 for the original item

      totalRow.style.display = 'flex';
      if (noteEl) noteEl.style.display = 'block';
      totalPrice.textContent = '$' + grandTotal.toFixed(2);
      countEl.textContent = itemCount;
    }
  }

  /* --- Resources Tab — Move Plytix resources into Dean tabs --- */
  function initResources() {
    var target = document.getElementById('dean-resources-target');
    if (!target) return;

    var resourcesBox = document.querySelector('.resources-box');

    if (resourcesBox) {
      var resourceLinks = resourcesBox.querySelector('.resources');
      if (resourceLinks) {
        target.innerHTML = '';
        target.appendChild(resourceLinks.cloneNode(true));
        resourcesBox.style.display = 'none';
      }
    }

    // Hide tab if no resources exist from either Plytix or metafields
    var hasPlytixResources = resourcesBox && resourcesBox.querySelector('.hc-resources-pdf');
    var hasMetafieldResources = document.querySelector('.dean-docs-grid');

    if (!hasPlytixResources && !hasMetafieldResources) {
      var docsTab = document.querySelector('[data-tab="documents"]');
      if (docsTab) docsTab.style.display = 'none';
    } else {
      var emptyMsg = target.querySelector('.dean-resources-empty');
      if (emptyMsg) emptyMsg.style.display = 'none';
    }
  }

  /* --- Video Section Wrapper — wraps YouTube iframes in styled containers --- */
  function initVideoSections() {
    var desc = document.querySelector('.dean-description');
    if (!desc) return;

    var iframes = desc.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]');
    iframes.forEach(function(iframe) {
      // Don't double-wrap
      if (iframe.parentElement.classList.contains('dean-video-section')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'dean-video-section';

      var label = document.createElement('div');
      label.className = 'dean-video-section-label';
      label.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="5 3 19 12 5 21 5 3"/></svg> Product Video';

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(label);
      wrapper.appendChild(iframe);
    });
  }

  /* --- Initialize Everything --- */
  function init() {
    initGallery();
    initQuantity();
    initVariants();
    initAddToCart();
    initNotify();
    initTabs();
    initFaq();
    initStickyBar();
    initReviewScroll();
    initAnimations();
    initReviewScroll();
    initRecentlyViewed();
    // Hide Expanse native recently-viewed section — we have our own
    document.querySelectorAll('[id^="RecentlyViewed"], [class*="recently-viewed-section"], .shopify-section:has([id^="RecentlyViewed"])').forEach(function(el) {
      el.style.display = 'none';
    });
    initFBT();
    initVendorCta();
    initResources();
    initVideoSections();
    initStampedSummaryControl();
    initPhoneHours();
    fixSwatches();
    hideEmptyLinkedProducts();
    moveFaqAboveReviews();
  }

  /* --- Stamped fixer ---
     Problem: Stamped sets bar colors as inline style="background-color:#f5a623"
     CSS !important CANNOT override inline styles — only JS can.
     Problem 2: Our fallback summary (top "5.0 / 6 reviews") must be hidden
     when Stamped renders its own summary.

     Strategy:
     - Inject a <style> tag that uses the attribute selector trick for known colors
     - ALSO use JS setAttribute to directly rewrite the inline style string
     - Poll with setInterval for 8 seconds to guarantee we catch late renders
     - MutationObserver handles pagination / lazy loading */
  function initStampedSummaryControl() {
    // Guard: never hide .spr-container — that's Shopify's native SPR reviews
    var sprStyle = document.createElement('style');
    sprStyle.textContent = '.spr-container, .spr-reviews, .spr-review { display: block !important; visibility: visible !important; }';
    document.head.appendChild(sprStyle);

    var DEAN_GOLD = '#C8971B';

    // ── Inject a <style> to catch any inline style Stamped sets ──
    // Using [style*=] attribute selector works for CSS overriding inline bg via filter
    var styleTag = document.createElement('style');
    styleTag.id = 'dean-stamped-override';
    styleTag.textContent = [
      /* Force bar fills to dean gold regardless of what Stamped inline-sets */
      '.summary-rating-bar-content { background-color: ' + DEAN_GOLD + ' !important; background: ' + DEAN_GOLD + ' !important; }',
      '.stamped-progress-bar { background-color: ' + DEAN_GOLD + ' !important; }',
      '.stamped-bar-fill { background-color: ' + DEAN_GOLD + ' !important; }',
      /* Hide our custom fallback completely — Stamped has its own */
      '.dean-reviews-summary--fallback { display: none !important; }'
    ].join('\n');
    document.head.appendChild(styleTag);

    function cleanReviewsFilter() {
      // Only touch Stamped-specific filter bars — never SPR elements
      var filterBars = document.querySelectorAll(
        '#stamped-main-widget .stamped-reviews-filter, #stamped-main-widget .stamped-reviews-toolbar'
      );
      filterBars.forEach(function(bar) {
        var selects = bar.querySelectorAll('select');
        selects.forEach(function(sel, idx) {
          if (idx > 0) {
            sel.style.setProperty('display', 'none', 'important');
            var parent = sel.parentElement;
            if (parent !== bar && parent.querySelectorAll('select').length === 1) {
              parent.style.setProperty('display', 'none', 'important');
            }
          }
        });
      });
    }

    function recolorBars() {
      // Confirmed from DOM inspection: Stamped uses .summary-rating-bar-content
      // Cast the widest possible net for bar elements across Stamped versions
      var selectors = [
        '.summary-rating-bar-content',           // ← CONFIRMED actual class
        '.stamped-progress-bar',
        '.stamped-bar-fill',
        '.stamped-histogram .stamped-progress > .stamped-progress-bar',
        '.stamped-summary-starrating-bar > span',
        '#stamped-main-widget [class*="progress-bar"]',
        '#stamped-main-widget [class*="bar-fill"]',
        '#stamped-main-widget [class*="bar-content"]',  // catches bar-content variants
        '.stamped-container [class*="progress"]'
      ];
      var bars = document.querySelectorAll(selectors.join(', '));

      bars.forEach(function(bar) {
        // Directly rewrite the style attribute string — most reliable method
        var existing = bar.getAttribute('style') || '';
        // Replace any background / background-color declaration in the inline style
        var cleaned = existing
          .replace(/background-color\s*:[^;]+;?/gi, '')
          .replace(/background\s*:[^;]+;?/gi, '')
          .trim();
        bar.setAttribute('style', cleaned + '; background-color: ' + DEAN_GOLD + ' !important; background: ' + DEAN_GOLD + ' !important;');
      });

      // Also recolor stars with inline color
      var stars = document.querySelectorAll(
        '#stamped-main-widget .stamped-fa-star, ' +
        '#stamped-main-widget .stamped-fa-star-half-o, ' +
        '.stamped-container .stamped-fa-star'
      );
      stars.forEach(function(s) {
        var sStyle = (s.getAttribute('style') || '').replace(/color\s*:[^;]+;?/gi, '').trim();
        s.setAttribute('style', sStyle + '; color: ' + DEAN_GOLD + ' !important;');
      });

      // Hide the fallback summary block (belt + suspenders alongside CSS)
      var fallback = document.querySelector('.dean-reviews-summary--fallback');
      if (fallback) fallback.setAttribute('style', 'display: none !important;');
    }

    // Poll every 300ms for the first 8 seconds — catches any render timing
    var pollCount = 0;
    var poller = setInterval(function() {
      recolorBars();
      cleanReviewsFilter();
      pollCount++;
      if (pollCount >= 27) clearInterval(poller); // stop after ~8s
    }, 300);

    // Recolor once after Stamped finishes initial render — don't interrupt with observer
    setTimeout(recolorBars, 1500);
    setTimeout(recolorBars, 3000);
  }


  // ── Swatch visibility fix + color panel detection ──
  // Map color names (from HC data-color attr) to hex values
  var SWATCH_COLORS = {
    'navy': '#1a2a6c', 'navy blue': '#1a2a6c',
    'teal': '#008080', 'turquoise': '#40e0d0',
    'white': '#ffffff', 'ivory': '#fffff0', 'cream': '#fffdd0', 'pumpkin spice': '#bb6f2b', 'sunkissed orange': '#f47920',
    'yellow': '#f5d800', 'lemon yellow': '#f5d800', 'mimosa yellow': '#f0e060', 'school bus yellow': '#f8c800',
    'gold': '#c89520', 'orange': '#f47920', 'sunflower': '#de9837', 'eggshell': '#cbc5b5',
    'red': '#cc2200', 'burgundy': '#800020', 'maroon': '#800000',
    'purple': '#6a0dad', 'lavender': '#c9a0dc', 'lilac': '#c8a2c8',
    'pink': '#f4a7b9', 'hot pink': '#ff69b4', 'rose': '#ff007f',
    'green': '#3a7d44', 'lime': '#7ec850', 'hunter green': '#355e3b',
    'black': '#222222', 'charcoal': '#444444', 'silver': '#c0c0c0', 'gray': '#888888', 'grey': '#888888',
    'blue': '#1560bd', 'royal blue': '#1560bd', 'baby blue': '#89cff0', 'light blue': '#add8e6',
    'brown': '#7b3f00', 'tan': '#d2b48c',
    'coral': '#ff6b6b', 'peach': '#ffcba4',
    'mint': '#98ff98', 'sage': '#9dc183',
  };

  function colorNameToHex(name) {
    if (!name) return null;
    return SWATCH_COLORS[name.toLowerCase().trim()] || null;
  }

  function applySwatchColors(scope) {
    var root = scope || document;
    root.querySelectorAll('.hc-linked-product-selector__color-swatches li, .dean-color-swatches li').forEach(function(li) {
      var colorName = li.getAttribute('data-color') || '';
      var hex = colorNameToHex(colorName);
      var link = li.closest('a') || li.querySelector('a');
      if (!link) return;

      // Hide the product photo — we use solid color instead
      var img = link.querySelector('img');
      if (img) img.style.setProperty('display', 'none', 'important');

      // Apply color as background
      if (hex) {
        link.style.setProperty('background-color', hex, 'important');
        link.style.setProperty('background-image', 'none', 'important');
      }

      // Add/update tooltip showing color name
      if (colorName) {
        link.setAttribute('title', colorName);
        link.setAttribute('aria-label', colorName);
        // Create visible tooltip span
        if (!link.querySelector('.dean-swatch-tooltip')) {
          var tip = document.createElement('span');
          tip.className = 'dean-swatch-tooltip';
          tip.textContent = colorName;
          link.appendChild(tip);
        }
      }
    });
  }

  function fixSwatches() {
    // DOM fact: HC Linked Products sets class "hc-linked-product-selector__color-swatches"
    // on the wrapper div when the selector type is color swatches.
    // Tag those panels with dean-color-swatches for CSS scoping.

    // Primary: use the HC class directly (most reliable)
    var colorWrappers = document.querySelectorAll('.hc-linked-product-selector__color-swatches');
    colorWrappers.forEach(function(wrapper) {
      var panel = wrapper.querySelector('.hc-linked-product-selector__select-panel');
      if (panel) panel.classList.add('dean-color-swatches');
    });
    // Fallback: label text detection for any cases without the explicit class
    var allSelectors = document.querySelectorAll('.hc-linked-product-selector');
    allSelectors.forEach(function(sel) {
      var label = sel.querySelector('.hc-linked-product-selector__label');
      if (label && label.textContent.toLowerCase().indexOf('color') > -1) {
        var panel = sel.querySelector('.hc-linked-product-selector__select-panel');
        if (panel) panel.classList.add('dean-color-swatches');
      }
    });

    applySwatchColors();

    setTimeout(applySwatchColors, 300);
    setTimeout(applySwatchColors, 1000);

    // Watch for HC app rendering swatches dynamically, then apply colors
    if (window.MutationObserver) {
      var swatchObserver = new MutationObserver(function() {
        applySwatchColors();
      });
      var linkedContainers = document.querySelectorAll(
        '.hc-linked-products-variants-container, .dean-linked-wrapper'
      );
      linkedContainers.forEach(function(c) {
        swatchObserver.observe(c, { childList: true, subtree: true });
      });
    }
  }


  // ── Ask a Question — always visible, toggle expand ──


    // ── Move FAQ section above reviews + fix indentation ──
  function moveFaqAboveReviews() {
    // Delay 150ms so Expanse theme JS finishes any section re-ordering first
    setTimeout(function() {
      // Primary: exact section ID (stable since template JSON defines it).
      // Fallback: .accordions-section class from faq-accordions schema.
      var faqWrapper = document.getElementById('shopify-section-a2435383-4d5e-4ef4-afe3-5ab98f6b8056')
                    || document.querySelector('.accordions-section');
      var reviewsSection = document.querySelector('#dean-tab-reviews');
      if (!faqWrapper || !reviewsSection) return;

      // Move FAQ before reviews inside .dean-content-section
      reviewsSection.parentElement.insertBefore(faqWrapper, reviewsSection);
      faqWrapper.classList.add('dean-faq-moved');

      // Move prop65 immediately BEFORE FAQ: desc/specs → prop65 → FAQ → reviews
      var prop65 = document.querySelector('[id*="product-prop65"]');
      if (prop65) {
        faqWrapper.insertAdjacentElement('beforebegin', prop65);
        prop65.classList.add('dean-prop65-before-faq');
      }
    }, 150);
  }

  // ── Hide linked product containers with only 1 item (current product = self) ──
  function hideEmptyLinkedProducts() {
    // HC structure: .dean-linked-wrapper > article > #shopify-section-linked-product-swatches
    //   > .hc-linked-product-selector (one per dimension: colors, sizes)
    //     > .hc-linked-product-selector__label
    //     > ul.hc-linked-product-selector__select-panel > a > li
    //
    // Rule: hide only the INDIVIDUAL selector (label + panel) with ≤1 item.
    // Do NOT hide the whole wrapper — a product may have 1 color but many sizes.
    // Only hide the wrapper if ALL selectors inside it have ≤1 item.

    function evaluateSelector(selector) {
      var panel = selector.querySelector('.hc-linked-product-selector__select-panel');
      if (!panel) return false; // panel not rendered yet
      var items = panel.querySelectorAll('li');
      if (items.length === 0) return false; // HC hasn't injected items yet
      if (items.length <= 1) {
        selector.style.setProperty('display', 'none', 'important');
      }
      return true; // rendered, evaluation done
    }

    function checkAll() {
      // Evaluate each individual selector block
      document.querySelectorAll('.hc-linked-product-selector').forEach(evaluateSelector);

      // Also hide the whole .dean-linked-wrapper if every selector inside is hidden
      document.querySelectorAll('.dean-linked-wrapper').forEach(function(wrapper) {
        var selectors = wrapper.querySelectorAll('.hc-linked-product-selector');
        if (selectors.length === 0) return;
        var allHidden = true;
        selectors.forEach(function(s) {
          if (s.style.display !== 'none') allHidden = false;
        });
        if (allHidden) {
          wrapper.style.setProperty('display', 'none', 'important');
        }
      });
    }

    // MutationObserver on the article containers
    var articles = document.querySelectorAll('article.hc-linked-products-variants-container, .dean-linked-wrapper');
    if (articles.length > 0) {
      var observer = new MutationObserver(function() {
        requestAnimationFrame(checkAll);
      });
      articles.forEach(function(el) {
        observer.observe(el, { childList: true, subtree: true });
      });
      setTimeout(function() { observer.disconnect(); }, 10000);
    }

    checkAll();
    setTimeout(checkAll, 300);
    setTimeout(checkAll, 1000);
    setTimeout(checkAll, 3000);
  }

  /* --- Vendor CTA Rotation --- */
  function initVendorCta() {
    var el = document.querySelector('.dean-vendor-cta');
    if (!el) return;

    var vendor = el.dataset.vendor || '';
    var count  = parseInt(el.dataset.count || '0');
    var hasCount = count >= 40;
    var vendorLower = vendor.toLowerCase().replace(/[^a-z]/g, '');

    // ShopAtDean house brand — totally different messaging
    if (vendorLower === 'shopatdean' || vendorLower.includes('shopatdean') || vendorLower.includes('deanpro')) {
      var houseCtas = [
        'See everything we carry →',
        'Browse our full selection →',
        'Explore our complete catalog →',
        'See all products we offer →',
        'Browse {N} products in our catalog →',
        'Shop our full inventory →',
        'See what else we have in stock →',
      ];
      var d = new Date();
      var seed = d.getFullYear() * 1000 + Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
      var idx = seed % houseCtas.length;
      var cta = houseCtas[idx].replace(/\{N\}/g, count > 0 ? count : 'all our');
      el.innerHTML = cta;
      return;
    }

    // Psychology-driven CTA banks
    // High count (40+ products) — lead with the number for authority + FOMO
    var countCtas = [
      'Browse all {N} {V} products →',
      '{N} {V} products — find your match →',
      'We stock {N} {V} products. See them all →',
      '{N} {V} options. Your kitchen, your choice →',
      'Over {N} {V} products trusted by operators →',
      'Choose from {N} {V} products — all in stock →',
      '{N} {V} products. The right one is in there →',
    ];

    // No count or under 40 — psychological triggers: curiosity, social proof, urgency, completion
    var genericCtas = [
      'See everything {V} makes →',                          // completeness
      'More {V} products loved by pros →',                   // social proof
      'Complete your {V} setup →',                           // completion bias
      'Other operators are buying these {V} items →',        // social proof
      'Don’t miss a {V} product that fits your kitchen →', // FOMO
      'Build your {V} collection →',                         // ownership
      'Stock up — see the full {V} line →',             // action + urgency
      '{V} makes more than you think. Explore →',            // curiosity gap
      'Find the right {V} product for your operation →',     // specificity
      'Everything {V} — all in one place →',            // convenience
      'Pros trust {V}. See why →',                           // authority + curiosity
      'The full {V} lineup, ready to ship →',                // availability
    ];

    var pool = hasCount ? countCtas : genericCtas;

    // Seed with a daily-stable value so it doesn't flash on every load
    // but still rotates — use day of year + vendor chars as seed
    var d = new Date();
    var seed = d.getFullYear() * 1000 + Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
    var vendorSeed = vendor.split('').reduce(function(a, c) { return a + c.charCodeAt(0); }, 0);
    var idx = (seed + vendorSeed) % pool.length;

    var cta = pool[idx]
      .replace(/\{V\}/g, vendor)
      .replace(/\{N\}/g, count);

    el.innerHTML = cta;
  }

  /* --- Stamped Re-init --- */
  function initStamped() {
    // Stamped's JS runs once on page load. If our widget renders after,
    // it needs to be re-triggered. Call init() if available, else poll.
    function tryInit() {
      if (window.StampedFn && typeof window.StampedFn.init === 'function') {
        window.StampedFn.init();
        return true;
      }
      if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
        window.StampedFn.loadBadges();
        return true;
      }
      return false;
    }

    if (!tryInit()) {
      // Stamped not loaded yet — wait for it
      var attempts = 0;
      var poll = setInterval(function() {
        if (tryInit() || attempts++ > 20) clearInterval(poll);
      }, 300);
    }
  }

  // Run on DOM ready


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
